import { HelpIcon } from './HelpIcon';

export function BooleanField({ id, label, value, onChange, helpText, readOnly }) {
  return (
    <div className="fw fw-bool">
      <div id={`field-${id}`}
        className={`toggle${value ? ' toggle-on' : ''}${readOnly ? ' toggle-ro' : ''}`}
        onClick={() => !readOnly && onChange(!value)}
        role="switch" aria-checked={value} tabIndex={readOnly ? -1 : 0}
        onKeyDown={e => { if ((e.key === ' ' || e.key === 'Enter') && !readOnly) { e.preventDefault(); onChange(!value); } }}>
        <span className="toggle-knob" />
      </div>
      <label className="toggle-lbl" htmlFor={`field-${id}`}>
        {label}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
    </div>
  );
}
